/**
 * Shared email validation for login and signup flows.
 * Use this utility whenever an email must be validated (e.g. on form submit).
 */

export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/**
 * Returns true if the trimmed string is a valid email format.
 */
export function isValidEmail(value: string): boolean {
  const trimmed = value.trim();
  return trimmed.length > 0 && emailRegex.test(trimmed);
}

/**
 * Undo common query-string corruption: URLSearchParams decodes "+" as space in the
 * application/x-www-form-urlencoded grammar. For values read from ?email=...,
 * map spaces in the local part back to "+" so aliases like user+tag@x.com survive.
 */
export function normalizeEmailFromUrlQuery(decoded: string): string {
  const trimmed = decoded.trim();
  if (!trimmed) {
    return trimmed;
  }
  const at = trimmed.indexOf('@');
  if (at <= 0) {
    return trimmed;
  }
  const local = trimmed.slice(0, at).replace(/\s+/g, '+');
  return `${local}@${trimmed.slice(at + 1)}`;
}
